import { render } from "./UserRequest.vue?vue&type=template&id=347b46c6"
import script from "./UserRequest.vue?vue&type=script&lang=js"
export * from "./UserRequest.vue?vue&type=script&lang=js"

import "./UserRequest.vue?vue&type=style&index=0&id=347b46c6&lang=css"

import exportComponent from "D:\\Shivani\\myProjects\\p2p_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__